<div
  class="mx-auto mt-10 flex w-full max-w-[856px] flex-col items-center rounded-md border border-border-3 bg-white px-24 py-14"
>
  <app-onboarding-svg-3 />

  <h1 class="mt-10 text-2xl font-bold leading-none">{{ 'onboarding.size-chart-created-successfully' | translate }}</h1>
  <p class="mt-4 text-center text-text-6">
    {{ 'onboarding.you-can-assign-products-anytime-from-chart-settings' | translate }}
  </p>

  <button mat-flat-button class="mt-10 w-full" (click)="onViewChart()">
    {{ 'onboarding.view-chart' | translate }}
  </button>

  <button mat-button class="mt-2 w-full" (click)="onNavigateToDashboard()">
    {{ 'onboarding.go-to-dashboard' | translate }}
  </button>
</div>
